import { useMutation } from "@tanstack/react-query";
import { showToast } from "../../../utils/toast";
import { createTaskLabel } from "../api";

export const useCreateTaskLabelMutation = () =>
  useMutation({
    mutationFn: createTaskLabel,

    onError: (error: any) => {
      if (error.isBusinessError) {
        showToast.error(error.message); // backend business error
        return;
      }

      if (error.isNetworkError) {
        showToast.error("Network error. Please try again.");
        return;
      }

      showToast.error("Something went wrong");
    },

    onSuccess: () => {
      showToast.success("Label created successfully");
    },
  });
